import axios from "./axios";
import Cookies from 'js-cookie';


export const verifyAdmin = async (token) => {
    const response = await axios.post("/admin/auth/verify", {}, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response.data;
}

export const loginAdmin = async (username, password, activityId) => {
    const response = await axios.post("/admin/auth/login", {
        username,
        password,
        activityId: Number(activityId)
    })
    if (response.data.success) { 
        const token = response.data.data.token;
        localStorage.setItem('adminActivityId', activityId);
        axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        Cookies.set('adminToken', token, { expires: 7 }); // Store token in cookie for 7 days
    }
    return response;
}

export const logoutAdmin = () => {
    Cookies.remove('adminToken');
    delete axios.defaults.headers.common['Authorization'];
}